import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/", { replace: true });
      return;
    }

    const sessionId = match[1];
    
    // Clear the hash immediately to prevent re-processing on re-renders
    window.history.replaceState(null, "", window.location.pathname + window.location.search);

    (async () => {
      try {
        const resp = await axios.get(`${API}/auth/session`, {
          params: { session_id: sessionId },
          withCredentials: true,
        });
        const { user: userData, token, session_token } = resp.data;
        login(userData, token, session_token);
        // Small delay to ensure state propagates before navigation
        setTimeout(() => {
          navigate("/account", { replace: true });
        }, 100);
      } catch (err) {
        console.error("OAuth callback error:", err);
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, login]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--color-cream)]">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-[var(--color-gold)] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-body text-[var(--color-text-mid)]">Signing you in...</p>
      </div>
    </div>
  );
}
